<template>
    <div class="password">
        <div class="form-control-icon mb-2" :class="validation">
            <i class="icon fa-regular fa-lock-keyhole" :class="validationIcon"></i>
            <input class="form-control custom-form" :type="password ? 'password' : 'text'" :value="modelValue"
                @input="updateValue" name="password" autocomplete="on" placeholder="Insira sua senha"/>
            <i v-on:click="showPassword" class="icon-eye" :class="classPassword" />
        </div>
    </div>
</template>
<script>
// import IconPassword from '../../assets/img/icon-password.svg'


export default {
    name: "input-password",

    data() {
        return {
            password: true,
            classPassword: '',
            valor: "",
        }
    },
    props: {
        modelValue: {
            type: String,
            default: '',
            required: true
        },
        validation: {
            type: String,
            default: '',
            required: true
        },
        validationIcon: {
            type: Object,   
        }
    },
    methods: {
        showPassword() {
            this.password = !this.password;
            if (!this.password) {
                this.classPassword = 'icon-eye-close';
            } else {
                this.classPassword = ""
            }

        }
    },

    setup(props, context) {
        const updateValue = (event) => {
            context.emit('update:modelValue', event.target.value);
        }

        return { updateValue }
    }

}

</script>
<style scoped>
.password {
    position: relative;
    z-index: 0;
}

.custom-form {
    padding-right: 30px;
}

.icon-eye {
    position: absolute;
    z-index: 1;
    right: 15px;
    /* top: calc(50% - 12.5px); */
    top: 0;
    width: 25px;
    height: 100%;
    background-image: url('../../assets/img/icon-password.svg');
    background-size: contain;
    background-position-y: center;
    background-position-x: center;
    background-repeat: no-repeat;
    cursor: pointer;
}

.icon-eye-close {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.82685 3.42286C6.18045 2.39798 7.91599 1.61759 9.99986 1.61759C12.4687 1.61759 14.4457 2.71198 15.8848 4.01194C17.3148 5.3012 18.2712 6.8192 18.7234 7.90646C18.8242 8.14114 18.8242 8.40255 18.7234 8.63723C18.314 9.59675 17.492 10.9484 16.282 12.1545L19.4964 14.6023C19.8142 14.8459 19.8723 15.2945 19.6217 15.6034C19.3712 15.9123 18.9098 15.9688 18.592 15.7252L0.503149 1.9411C0.184396 1.6981 0.12851 1.25012 0.378361 0.940168C0.628242 0.63027 1.08902 0.575936 1.40801 0.818846L4.82685 3.42286ZM6.02156 4.33574L7.4271 5.40517C8.1146 4.82292 9.01598 4.46942 9.99986 4.46942C12.1601 4.46942 13.9109 6.1716 13.9109 8.27184C13.9109 8.90162 13.7551 9.49278 13.4771 10.0156L15.1209 11.2692C16.1445 10.2562 16.9023 9.07689 17.2904 8.27184C16.8473 7.35391 16.062 6.11812 14.8856 5.05463C13.6298 3.92282 11.9921 3.01677 9.99986 3.01677C8.45682 3.01677 7.10016 3.5702 6.02156 4.33574ZM12.2884 9.10957C12.3893 8.84815 12.4443 8.56594 12.4443 8.24511C12.4443 6.95882 11.3504 5.86859 9.99986 5.86859C9.97847 5.86859 9.96014 5.89533 9.91125 5.89533C9.97847 6.04683 9.99986 6.20724 9.99986 6.34389C9.99986 6.67364 9.92653 6.95882 9.79819 7.21132L12.2884 9.10957ZM12.5757 12.9803L13.8559 13.9606C12.7468 14.5429 11.4604 14.9261 9.99986 14.9261C7.53099 14.9261 5.55406 13.8329 4.11491 12.5318C2.68553 11.2158 1.72976 9.69775 1.2751 8.63723C1.17488 8.40255 1.17488 8.14114 1.2751 7.90646C1.5666 7.22618 2.06434 6.34687 2.761 5.46458L3.91324 6.34686C3.34186 7.03903 2.96481 7.72525 2.71089 8.24511C3.12553 9.16304 3.93769 10.4256 5.11407 11.4891C6.36989 12.6209 8.00765 13.5002 9.99986 13.5002C10.9379 13.5002 11.7965 13.3041 12.5757 12.9803ZM6.08878 8.24511C6.08878 8.1857 6.09184 8.10252 6.09795 8.01934L7.8121 9.33237C8.13293 9.95917 8.73181 10.4285 9.44986 10.5622L11.1671 11.902C10.7974 11.9881 10.4062 12.0743 9.97236 12.0743C7.8396 12.0743 6.06128 10.3721 6.06128 8.24511H6.08878Z' fill='%23000'/%3E%3C/svg%3E%0A");
}
</style>